import { Link } from "react-router-dom";
import { BlueprintBackground } from "@/components/BlueprintBackground";
import { Logo } from "@/components/Logo";
import { Wordmark } from "@/components/Wordmark";

export default function NotFound() {
  return (
    <div className="min-h-screen flex items-center justify-center px-4" data-testid="not-found-page">
      <BlueprintBackground />
      <div className="w-full max-w-sm text-center">
        <Link to="/" className="flex items-center justify-center gap-2 mb-8">
          <Logo size={26} />
          <Wordmark className="font-heading text-xl font-bold tracking-tight text-white" />
        </Link>
        <div className="rounded-2xl border border-slate-700/60 bg-slate-900/80 backdrop-blur-md p-8 shadow-2xl">
          <h1 className="font-heading text-2xl font-bold text-white mb-2">Page not found</h1>
          <p className="text-slate-400 text-sm mb-6">This page doesn't exist or has moved.</p>
          <Link to="/dashboard" className="text-blue-400 hover:text-blue-300 font-medium text-sm" data-testid="not-found-dashboard-link">
            Back to Dashboard
          </Link>
        </div>
      </div>
    </div>
  );
}
